"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SCOPES = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _app = _interopRequireDefault(require("firebase/app"));
require("firebase/auth");
var _authorizations = _interopRequireDefault(require("./authorizations"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var SCOPES = exports.SCOPES = ['email', 'profile'];

/**
 Authentification (SignIn & Authorization) With Firebase App

 Constructor:
 - config : Object      | Required | Firebase Config ('apiKey', 'authDomain', 'projectId', 'appId') and 'application' must be specified
 - app    : FirebaseApp | Optional | If not set, the lib initialze a "DEFAULT" Firebase App

 Methods:
 - signIn()        : return Promise<FirebaseAuth> when user is signed in
 - authorization() : return Authorized User object. Reject if user isn't authorized
 **/
var FirebaseAuth = exports["default"] = /*#__PURE__*/function () {
  function FirebaseAuth(config, app) {
    var dev = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    (0, _classCallCheck2["default"])(this, FirebaseAuth);
    this.config = this.checkConfig(config);
    this.app = app || _app["default"].initializeApp(config);
    this.dev = dev;
  }
  (0, _createClass2["default"])(FirebaseAuth, [{
    key: "signIn",
    value: function signIn() {
      var _this = this;
      return this.signInFirebase().then(this.checkDomain).then(function (firebaseUser) {
        return _this.firebaseUser = firebaseUser;
      }).then(function () {
        return _this;
      });
    }
  }, {
    key: "signInFirebase",
    value: function signInFirebase() {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var unsubscribe = _this2.app.auth().onAuthStateChanged(function (firebaseUser) {
          try {
            unsubscribe();
            if (firebaseUser) {
              resolve(firebaseUser);
            } else {
              // no user => directly redirect to signIn
              var provider = _this2.getGoogleFirebaseProvider();
              // SignIn with popup in case of PWA on mobile. In this case, if redirect is too quick, the browser think it's an ads
              if (window.matchMedia('(display-mode: standalone)').matches && !/iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())) {
                console.log('display-mode is standalone');
                return _this2.app.auth().signInWithPopup(provider)["catch"](function (error) {
                  console.log(error);
                  console.log('Unable to signIn with popup, try with redirect');
                  return _this2.app.auth().signInWithRedirect(provider);
                });
              }
              return _this2.app.auth().signInWithRedirect(provider);
            }
          } catch (error) {
            reject(error);
          }
        });
      });
    }
  }, {
    key: "checkDomain",
    value: function checkDomain(firebaseUser) {
      if (/.+@(.*\.)?(auchan|partisansdugout)\.(fr|com|lu)$/g.test(firebaseUser.email)) return Promise.resolve(firebaseUser);else throw 'Unauthorized user account';
    }
  }, {
    key: "getGoogleFirebaseProvider",
    value: function getGoogleFirebaseProvider() {
      var provider = new _app["default"].auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      var _iterator = _createForOfIteratorHelper(this.config.scopes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var scope = _step.value;
          provider.addScope(scope);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return provider;
    }
  }, {
    key: "authorization",
    value: function authorization() {
      var _this3 = this;
      var application = this.config.application;
      var firebaseUser = this.firebaseUser;
      if (!application || !firebaseUser) throw 'No auth user, or application is not confiured';
      return firebaseUser.getIdToken(true).then(function (idToken) {
        return (0, _authorizations["default"])(idToken, application, _this3.dev);
      }).then( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(userInfos) {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.firebaseUser.getIdTokenResult(true).then(function (idTokenResult) {
                  return idTokenResult.claims.roles;
                });
              case 2:
                _this3.roles = _context.sent;
                _this3.user = userInfos;
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (error) {
        var _error$context = error.context,
          roles = _error$context.roles,
          userInfos = _error$context.userInfos;
        throw {
          roles: roles,
          userInfos: userInfos,
          firebaseUser: _this3.firebaseUser
        };
      }).then(function () {
        return _this3;
      });
    }
  }, {
    key: "checkConfig",
    value: function checkConfig(config) {
      if (!config) throw 'No config specified';
      for (var _i = 0, _arr = ['apiKey', 'authDomain', 'projectId', 'appId', 'application']; _i < _arr.length; _i++) {
        var attribut = _arr[_i];
        if (!config[attribut]) {
          throw "Config: attribute ".concat(attribut, " is missing");
        }
      }
      for (var _i2 = 0, _SCOPES = SCOPES; _i2 < _SCOPES.length; _i2++) {
        var scope = _SCOPES[_i2];
        if (!config.scopes || !config.scopes.includes(scope)) {
          config.scopes = config.scopes || [];
          config.scopes.push(scope);
        }
      }
      return config;
    }
  }]);
  return FirebaseAuth;
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@perfweb/auth-lib/lib/firebaseAuth.js
// module id = NGjJ
// module chunks = 5